import React from 'react'
import { Controller } from 'react-hook-form'
import { TextField, Grid } from '@material-ui/core'

const DocumentTextField = ({ input, control, setValue, ...rest }) => {
  const applyCpfMask = (value) => {
    value = value.replace(/\D/g, '') // Remove tudo que não é número
    value = value.replace(/(\d{3})(\d)/, '$1.$2') // Coloca o primeiro ponto
    value = value.replace(/(\d{3})(\d)/, '$1.$2') // Coloca o segundo ponto
    value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2') // Coloca o traço
    return value
  }

  const applyCnpjMask = (value) => {
    value = value.replace(/\D/g, '')
    value = value.replace(/(\d{2})(\d)/, '$1.$2')
    value = value.replace(/(\d{3})(\d)/, '$1.$2')
    value = value.replace(/(\d{3})(\d)/, '$1/$2')
    value = value.replace(/(\d{4})(\d{1,2})$/, '$1-$2')
    return value
  }

  const applyMask = (value) => {
    const cleanValue = value.replace(/\D/g, '') // Remove tudo que não é número
    if (cleanValue.length <= 11) {
      // Aplica a máscara de CPF se o valor tiver até 11 dígitos
      return applyCpfMask(value)
    } else {
      // Aplica a máscara de CNPJ se o valor tiver mais de 11 dígitos
      return applyCnpjMask(value)
    }
  }

  const determineDocumentType = (document) => {
    if (!document) return ''

    // Remove caracteres especiais para contar apenas os números
    const cleanDocument = document.replace(/\D/g, '')

    if (cleanDocument.length === 11) {
      return 'CPF'
    } else if (cleanDocument.length === 14) {
      return 'CNPJ'
    }

    return ''
  }

  return (
    <Grid
      item
      xs={input?.width[0] || 12}
      sm={input?.width[1] || 12}
      md={input?.width[2] || 12}
      lg={input?.width[3] || 12}
      key={input.id}
    >
      <Controller
        name={input.name}
        control={control}
        defaultValue=""
        as={
          <TextField
            type="text"
            label={input?.labelName}
            variant={input?.field?.variant}
            fullWidth={input?.field?.fullWidth}
            required={input?.field?.required}
            size={input?.field?.size}
            placeholder={input?.field?.placeholder}
          />
        }
        onChange={(e) => {
          if (e[0]?.target?.name === 'document') {
            const maskedValue = applyMask(e[0]?.target?.value)
            setValue(input.name, maskedValue)

            // Determina e preenche o documentType baseado no documento
            const documentType = determineDocumentType(maskedValue)
            if (documentType) {
              setValue('documentType', documentType)
            }

            return maskedValue
          } else {
            setValue(input.name, e[0]?.target?.value)
          }
        }}
      />
    </Grid>
  )
}

export default DocumentTextField
